import { useMutation } from '@tanstack/react-query';

import { handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { addGuarantor } from '../../requests/addGuarantor';

type AddGuarantorVariables = { uuid: string; data: Record<string, any> };

export const useAddGuarantor = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: AddGuarantorVariables) =>
      addGuarantor(constructPost, uuid, data),
    onSuccess: () => handleSuccess('Guarantor added successfully'),
  });
  return { addGuarantor: mutateAsync, ...rest };
};
